'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  height: ', ';\n  width: ', ';\n  border: 1px solid ', ';\n  border-radius: ', ';\n  text-align: center;\n  font-size: 17px;\n  color: ', ';\n  cursor: pointer;\n  overflow: hidden;\n  padding-top: 4px;\n  background: ', ';\n\n  &:hover {\n    color: ', ';\n    background: ', ';\n    border: none;\n  }\n'], ['\n  height: ', ';\n  width: ', ';\n  border: 1px solid ', ';\n  border-radius: ', ';\n  text-align: center;\n  font-size: 17px;\n  color: ', ';\n  cursor: pointer;\n  overflow: hidden;\n  padding-top: 4px;\n  background: ', ';\n\n  &:hover {\n    color: ', ';\n    background: ', ';\n    border: none;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  width: 15px;\n  position: absolute;\n  height: 15px;\n  background: ', ';\n  color: #FFF;\n  font-size: 10px;\n  border-radius: 100%;\n  margin-top: -12px;\n  display: block;\n  margin-left: 16px;\n'], ['\n  width: 15px;\n  position: absolute;\n  height: 15px;\n  background: ', ';\n  color: #FFF;\n  font-size: 10px;\n  border-radius: 100%;\n  margin-top: -12px;\n  display: block;\n  margin-left: 16px;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _color = require('../color');

var _color2 = _interopRequireDefault(_color);

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Icon = _styledComponents2.default.div(_templateObject, function (props) {
  return props.height;
}, function (props) {
  return props.width;
}, _color2.default.grey_accent_1, function (props) {
  return props.variant === 'square' ? '5px' : '100%';
}, _color2.default.blue_accent, function (props) {
  return props.backgroundColor;
}, function (props) {
  return props.hoverColor ? props.hoverColor : _color2.default.white;
}, _color2.default.blue_accent);

var Indicator = _styledComponents2.default.div(_templateObject2, _color2.default.r34);

var MozartIcon = function MozartIcon(props) {
  var style = props.style,
      onClick = props.onClick,
      data = props.data,
      hoverColor = props.hoverColor,
      indicator = props.indicator,
      variant = props.variant,
      width = props.width,
      height = props.height,
      backgroundColor = props.backgroundColor,
      themeId = props.themeId;

  return _react2.default.createElement(
    Icon,
    {
      'data-qa': props.testId,
      onClick: onClick ? (0, _utils.throttle)(onClick, 3000) : onClick,
      style: style,
      variant: variant,
      hoverColor: hoverColor,
      width: width,
      height: height,
      backgroundColor: backgroundColor,
      'data-theme': themeId },
    indicator && _react2.default.createElement(
      Indicator,
      null,
      indicator
    ),
    data
  );
};

MozartIcon.propTypes = {
  /** qa attribute */
  testId: _propTypes2.default.string,
  /** theme attribute */
  themeId: _propTypes2.default.string,
  /** style override */
  style: _propTypes2.default.object,
  /** variant could be square or circle */
  variant: _propTypes2.default.string,
  /** content inside icon */
  data: _propTypes2.default.oneOf([_propTypes2.default.node, _propTypes2.default.string, _propTypes2.default.number]).isRequired,
  /** callback when click */
  onClick: _propTypes2.default.func,
  /** indicator */
  indicator: _propTypes2.default.oneOf([_propTypes2.default.node, _propTypes2.default.string, _propTypes2.default.number]),
  /** width custom */
  width: _propTypes2.default.string,
  /** width custom */
  height: _propTypes2.default.string,
  /** background color custom */
  backgroundColor: _propTypes2.default.string,
  /** hover color */
  hoverColor: _propTypes2.default.string
};

MozartIcon.defaultProps = {
  style: {},
  data: '',
  variant: 'circle',
  width: '31px',
  height: '31px',
  backgroundColor: 'inherit',
  testId: 'MozartIcon',
  themeId: 'MozartIcon'
};

exports.default = MozartIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Mozart/MozartIcon/MozartIcon.js
// module id = 310
// module chunks = 1